import * as actionTypes from './types/test';
import { createAction } from '@/utillity/createAction';

export const addTest = params => createAction(actionTypes.TEST_ADD.INIT, params);
export const getTestTypes = params => createAction(actionTypes.TEST_GET_TYPES.INIT, params);
export const getTest = params => createAction(actionTypes.TEST_GET_TEST.INIT, params);
export const editTest = params => createAction(actionTypes.TEST_EDIT.INIT, params);

export default addTest;
